// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"592eb5e6","434":"703a692d","455":"4afed04e","654":"2b5b6148","977":"d480f6e2"}[chunkId] + ".chunk.js";
};